export const folder = {
  name: "folder" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M1.6 5a.9.9 0 0 1 .9-.9h8a.9.9 0 0 1 .9.9v1.1h10.1a.9.9 0 0 1 .9.9v12a.9.9 0 0 1-.9.9h-19a.9.9 0 0 1-.9-.9V5Zm1.8.9v12.2h17.2V7.9H10.5a.9.9 0 0 1-.9-.9V5.9H3.4ZM5.1 11a.9.9 0 0 1 .9-.9h12a.9.9 0 0 1 0 1.8H6a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["folder"],
  category: "file" as const,
};
